export const editRecordColumns = [
  {
    label: '序号',
    value: 'num',
    width: 40
  },
  {
    label: '修改人',
    value: 'editorName',
    width: 150
  },
  {
    label: '修改时间',
    value: 'editTime',
    width: 100
  },
  {
    label: '题干',
    value: 'questionDetails',
    width: 150
  },
  {
    width: 200,
    label: '修改前答案',
    value: 'oldAnswerContentItem'
  },
  {
    width: 200,
    label: '修改后答案',
    value: 'newAnswerContentItem'
  }
]

export const mainColumns = [
  {
    label: '题号',
    value: 'num',
    width: 40
  },
  {
    width: 100,
    label: '题干',
    value: 'text'
  },
  {
    width: 200,
    label: '答案内容',
    value: 'answerContent'
  },
  {
    width: 100,
    label: '多媒体',
    value: 'media'
  }
]